import { EUserPermissions, EUserTypes } from 'constants/authentication';
import { routePaths } from 'constants/routes';
import { authenticatedKey, rolesKey, userKey } from 'constants/storage';
import { getItemStorage } from 'services/storage';
import { TUserTypeKey, TUserPermissionKey } from 'types/authentication';

/** Return logged user type by localStorage data */
export const getUserType = () => {
  const userStorage = getItemStorage(userKey);
  if (userStorage?.admin) {
    return 'admin';
  } else {
    return 'client';
  }
};

interface ICheckPermissionParams {
  policy?: TUserPermissionKey;
  onlyClient?: boolean;
  onlyAdmin?: boolean;
}

export const checkPermission = ({
  policy,
  onlyClient,
  onlyAdmin,
}: ICheckPermissionParams): boolean => {
  const userType = getUserType();

  if (onlyAdmin) {
    return userType === EUserTypes.admin;
  }

  if (userType === EUserTypes.admin && !onlyClient) {
    return true;
  }

  if (onlyClient && !policy && userType === EUserTypes.client) {
    return true;
  }

  if (userType === EUserTypes.client && policy) {
    const rolesStorage = getItemStorage(rolesKey) as { authority: string }[];

    const userHasPolicy = !!rolesStorage?.find(role => role.authority === EUserPermissions[policy]);

    return userHasPolicy;
  }

  return false;
};

interface IVerifyParam {
  isPrivate: boolean;
  isPublic: boolean;
  userType?: TUserTypeKey;
  policy?: TUserPermissionKey;
}

/** Return `true` if user is authenticated by params */
export const verifyAuthentication = ({ isPrivate, isPublic, userType, policy }: IVerifyParam) => {
  const isAuthenticated = !!(getItemStorage(authenticatedKey) || null);

  if (isPrivate) {
    const loggedUserType = getUserType();

    if (userType && isAuthenticated) {
      if (policy && loggedUserType === EUserTypes.client) {
        return checkPermission({ policy });
      }

      return EUserTypes[loggedUserType] === userType;
    }

    if (policy && loggedUserType === EUserTypes.client) {
      return checkPermission({ policy });
    }

    return isAuthenticated;
  }

  if (isPublic) {
    return !isAuthenticated;
  }

  return true;
};

export const getRedirectRoute = (isPublic: boolean) => {
  if (isPublic) {
    return routePaths.home;
  }
  return routePaths.login;
};
